import React, { FC, ReactNode } from 'react';
import { Tooltip } from 'antd';
import { WarningCircle } from 'common/svg';

interface IComponentProps {
  title: ReactNode;
}

export const InfoTooltip: FC<IComponentProps> = ({ title }) => (
  <Tooltip placement="right" overlayInnerStyle={{ padding: 12, borderRadius: 20 }} title={title}>
    <WarningCircle className="icon-gray" />
  </Tooltip>
);
